<template>
  <div class="w-full">
    <DatatableReportV3
      id="customers-table"
      ref="customer_table"
      title="Sub-Customers"
      :config="config"
      :source="source"
      :filters="filters"
      flat
      no-download
      subpage
    >
      <template #actions>
        <SeraButton
          icon="fa fa-plus fa-fw"
          text="Add Customer"
          @click="handleAddCustomer"
        />
      </template>
    </DatatableReportV3>
    <ConfirmUnarchiveModal
      :open="confirmUnarchiveModalOpen"
      @close="confirmUnarchiveModalOpen = false"
    />
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import SeraButton from "@/components/Button.vue";
import ConfirmUnarchiveModal from "@/Customer/ConfirmUnarchiveModal.vue";
import CustomerActionsMenu from "@/Customer/CustomerActionsMenu.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";

export default {
  components: {
    ConfirmUnarchiveModal,
    DatatableReportV3,
    SeraButton
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    customerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      mergeEnabled: window.currentTenant.merge_tools_enabled,
      config: {
        pageLength: 25,
        order: [[1, "asc"]],
        columns: [
          { data: "id", orderable: false, searchable: false },
          { data: "name" },
          { data: "email", className: "email-field" },
          { data: "phone", className: "phone-field" },
          {
            data: "address",
            title: "Service Address",
            orderable: false,
            className: "address-field"
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            className: "text-center th-no-text",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "customer-action-menu-vue",
            component: CustomerActionsMenu,
            options: {
              store
            }
          }
        ]
      },
      confirmUnarchiveModalOpen: false
    };
  },
  mounted() {
    EventBus.$on("refresh-customer-table", this.refreshData);
    EventBus.$on("confirm-unarchive", this.handleConfirmUnarchive);
  },
  beforeUnmount() {
    EventBus.$off("refresh-customer-table", this.refreshData);
    EventBus.$off("confirm-unarchive", this.handleConfirmUnarchive);
  },
  methods: {
    refreshData() {
      this.$refs.customer_table.refreshTable();
    },
    handleAddCustomer() {
      window.location.href =
        this.userCreatePath() + "?parent_id=" + this.customerId;
    },
    handleConfirmUnarchive() {
      this.confirmUnarchiveModalOpen = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
